




import moment from "moment";
import { Vue, Prop, Component } from "vue-property-decorator";

@Component
export default class DateTime extends Vue {
  @Prop() format!: string;
  private dateTime = "";
  private timer = -1;

  constructor() {
    super();
    const now = moment()
      .locale("cs")
      .format(this.format);
    this.dateTime = now.slice(0, 1).toUpperCase() + now.slice(1);
  }

  mounted() {
    this.timer = window.setInterval(this.updateDateTime, 1000);
  }

  private updateDateTime() {
    const now = moment()
      .locale("cs")
      .format(this.format);
    this.dateTime = now.slice(0, 1).toUpperCase() + now.slice(1);
  }

  destroyed() {
    clearInterval(this.timer);
  }
}
